import React, { useState } from "react";
import './QueryForm.css';
import { sharedData } from "../sharedData/sharedData";
import config from "../config/config";
import { MentionInput, MentionInputBox } from "./ui/MentionInputBox";
import { Input } from "./ui/Input";
import { userSession } from "../observers/userObserver";
const QueryForm = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    subject: "",
    description: ""
  });

  const [loading, setLoading] = useState(false);

  const isFormValid = () =>
    formData.subject.trim() !== "" && formData.description.trim() !== "";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const token = userSession.getToken()

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid()) return;

    const newQuery = {
      request_id: sharedData.get("requestId"),
      subject: formData.subject.trim(),
      description: formData.description.trim(),
    };

    try {
      setLoading(true);
      const response = await fetch(`${config["backend-url"]}/create_query`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(newQuery),
      });

      if (!response.ok) {
        console.error("Failed to create query:", response.statusText);
        return;
      }

      const data = await response.json();
      console.log("Query created successfully:", data);

      setFormData({ subject: "", description: "" });
      onSubmit?.();
    } catch (err) {
      console.error("Error while creating query:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="query-form" onSubmit={handleSubmit}>
      <Input 
        label="Subject"
        type="text"
        name="subject"
        value={formData.subject}
        onChange={handleChange}
        required
      />
      <MentionInputBox
        label="Description"
        name="description"
        value={formData.description}
        onChange={handleChange}
        required
      />
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "20px" }}>
        <p style={{
          margin: "0",
          padding: "8px 12px",
          backgroundColor: "#e7f3ff",
          border: "1px solid #b3d7ff",
          borderRadius: "4px",
          fontSize: "12px",
          color: "#333",
        }}>
          <strong>Note:</strong>&nbsp;To alert your MLNO or the COND team, tag them with <strong>@COND</strong> or <strong>@MLNO</strong> in the description field.
        </p>
        <button
          type="submit"
          className="submit-btn"
          disabled={!isFormValid() || loading}
          style={{
            backgroundColor: isFormValid() ? "#059a99" : "gray",
            alignSelf: "stretch",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "0"
          }}
        >
          {loading ? "Creating..." : "Create"}
        </button>
      </div>
    </form>
  );
};

export default QueryForm;
